export default {
  metadata: {
    version: '1.0.0',
    id: 'footer-links-grid-1.0.0',
    name: 'JDSFooterLinksGrid',
    platform: 'web'
  },
  hierarchy: {
    container: ['jds_footer_links']
  },
  base: {
    container: {
      'flex-direction': '{f_0}',
      size: '{f_1}',
      gap: '{f_2}',
      flex: 1
    }
  },
  api: {
    config: {},
    data: {
      container: {
        value: {
          type: 'list',
          name: 'links',
          object: {
            title: 'string',
            provider: 'object',
            subLinks: 'list'
          }
        }
      },
      jds_footer_links: {
        links: {
          type: 'list',
          name: 'links.subLinks'
        },
        title: {
          type: 'string',
          name: 'links.title'
        },
        provider: {
          type: 'object',
          name: 'links.provider'
        }
      }
    }
  }
};
